import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f339f440"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card mb-5" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "m-0" }
const _hoisted_5 = { class: "card-toolbar d-flex align-items-center gap-4" }
const _hoisted_6 = { class: "card-body" }
const _hoisted_7 = {
  key: 0,
  class: "loading-center"
}
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "table align-middle table-row-dashed fs-6 gy-3" }
const _hoisted_10 = { class: "text-start text-muted fw-bold fs-7 text-uppercase gs-0" }
const _hoisted_11 = { class: "w-150px" }
const _hoisted_12 = { class: "action-header" }
const _hoisted_13 = { class: "fw-semibold" }
const _hoisted_14 = { class: "action-col" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fw-bold mt-2 mb-2 fs-5" }, "Deposit", -1))
const _hoisted_17 = {
  key: 0,
  class: "border rounded p-3 mb-5"
}
const _hoisted_18 = { class: "table align-middle table-row-dashed fs-6 gy-2 mb-0" }
const _hoisted_19 = { class: "text-start text-muted fw-bold fs-7 text-uppercase gs-0" }
const _hoisted_20 = { class: "w-300px" }
const _hoisted_21 = { class: "w-150px" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "w-150px" }, "Active", -1))
const _hoisted_23 = {
  colspan: "3",
  class: "fw-semibold pt-6 pb-2"
}
const _hoisted_24 = { class: "mb-0" }
const _hoisted_25 = { class: "p-0" }
const _hoisted_26 = { class: "form-check form-switch form-switch-sm form-check-custom form-check-solid" }
const _hoisted_27 = ["checked"]
const _hoisted_28 = { class: "p-0" }
const _hoisted_29 = {
  key: 1,
  class: "text-muted fst-italic mb-5"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fw-bold mt-2 mb-2 fs-5" }, "Withdraw", -1))
const _hoisted_31 = {
  key: 2,
  class: "border rounded p-3"
}
const _hoisted_32 = { class: "table align-middle table-row-dashed fs-6 gy-2 mb-0" }
const _hoisted_33 = { class: "text-start text-muted fw-bold fs-7 text-uppercase gs-0" }
const _hoisted_34 = { class: "w-300px" }
const _hoisted_35 = { class: "w-150px" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "w-150px" }, "Active", -1))
const _hoisted_37 = {
  colspan: "3",
  class: "fw-semibold pt-6 pb-2"
}
const _hoisted_38 = { class: "mb-0" }
const _hoisted_39 = { class: "p-0" }
const _hoisted_40 = { class: "form-check form-switch form-switch-sm form-check-custom form-check-solid" }
const _hoisted_41 = ["checked"]
const _hoisted_42 = { class: "p-0" }
const _hoisted_43 = {
  key: 3,
  class: "text-muted fst-italic"
}
const _hoisted_44 = { class: "mt-4 d-flex justify-content-end gap-3" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-muted fs-7 mt-4" }, " Note: Toggling switches updates pending changes locally. Press Save / Save All to persist. ", -1))

import { ref, computed, onMounted } from "vue";
import { SiteTypes } from "@/core/types/SiteTypes";
import SystemService from "../../system/services/SystemService";
import PaymentService from "../services/PaymentService";
import { ElNotification } from "element-plus";
import { useI18n } from "vue-i18n";

const KEY_NAME = "PaymentAccessNamesForAutoOpenAccount";


export default /*#__PURE__*/_defineComponent({
  __name: 'PaymentAutoOpenConfig',
  setup(__props) {

const { t } = useI18n();

const isLoading = ref(true);
const isSubmitting = ref(false);
const configMeta = ref<any>(null);
const hideActive = ref(false);
const configValue = ref<Record<number, number[]>>({});
const hasOwnConfig = ref<Set<number>>(new Set());
const originalShapeIsArray = ref(false);
const drawerVisible = ref(false);
const currentSiteId = ref<number | null>(null);

const depositMethods = ref<any[]>([]);
const withdrawMethods = ref<any[]>([]);
const totalMethodCount = computed(
  () =>
    new Set([
      ...depositMethods.value.map((m) => m.id),
      ...withdrawMethods.value.map((m) => m.id),
    ]).size
);

const groupBy = (list: any[]) =>
  list.reduce((acc, cur) => {
    const g = cur.group?.trim() || "System Manual";
    (acc[g] ||= []).push(cur);
    return acc;
  }, {} as Record<string, any[]>);

const depositGroups = computed(() => {
  const groups = groupBy(depositMethods.value);
  return Object.keys(groups)
    .sort()
    .map((k) => ({ name: k, items: groups[k] }));
});
const withdrawGroups = computed(() => {
  const groups = groupBy(withdrawMethods.value);
  return Object.keys(groups)
    .sort()
    .map((k) => ({ name: k, items: groups[k] }));
});

const depositGroupsFiltered = computed(() => {
  if (!hideActive.value) return depositGroups.value;
  return depositGroups.value
    .map((g) => ({ name: g.name, items: g.items.filter((m) => m.status) }))
    .filter((g) => g.items.length);
});
const withdrawGroupsFiltered = computed(() => {
  if (!hideActive.value) return withdrawGroups.value;
  return withdrawGroups.value
    .map((g) => ({ name: g.name, items: g.items.filter((m) => m.status) }))
    .filter((g) => g.items.length);
});

// site rows
const siteTypeRows = [
  { id: SiteTypes.Default },
  { id: SiteTypes.BritishVirginIslands },
  { id: SiteTypes.Australia },
  { id: SiteTypes.China },
  { id: SiteTypes.Taiwan },
  { id: SiteTypes.Vietnam },
  { id: SiteTypes.Japan },
  { id: SiteTypes.BBL },
  { id: SiteTypes.Malaysia },
];

const criteria = {
  page: 1,
  size: 500,
  sortField: "Sequence",
  sortFlag: false,
};

const metaBySite = ref<Record<number, any>>({});

const arraysEqual = (a: number[] = [], b: number[] = []) => {
  if (a.length !== b.length) return false;
  const sa = [...a].sort((x, y) => x - y);
  const sb = [...b].sort((x, y) => x - y);
  return sa.every((v, i) => v === sb[i]);
};

const loadConfigs = async () => {
  let defList: number[] = [];
  try {
    const defRes = await SystemService.queryConfigByKey("Public", 0, KEY_NAME);
    if (defRes) {
      metaBySite.value[0] = {
        key: defRes.key || KEY_NAME,
        name: defRes.name || defRes.Name || KEY_NAME,
        dataFormat:
          defRes.dataFormat || defRes.DataFormat || defRes.format || "Json",
        description: defRes.description || defRes.Description || "",
      };
      if (Array.isArray(defRes.value)) defList = defRes.value;
    }
  } catch {
    metaBySite.value[0] = {
      key: KEY_NAME,
      name: KEY_NAME,
      dataFormat: "Json",
      description: "",
    };
  }
  configValue.value[0] = defList;

  await Promise.all(
    siteTypeRows
      .filter((s) => s.id !== 0)
      .map(async (s) => {
        try {
          const res = await SystemService.queryConfigByKey(
            "Public",
            s.id,
            KEY_NAME
          );
          if (res && Array.isArray(res.value) && res.value.length > 0) {
            if (!arraysEqual(res.value, defList)) {
              configValue.value[s.id] = [...res.value];
              hasOwnConfig.value.add(s.id);
              metaBySite.value[s.id] = {
                key: res.key || KEY_NAME,
                name: res.name || res.Name || KEY_NAME,
                dataFormat:
                  res.dataFormat || res.DataFormat || res.format || "Json",
                description: res.description || res.Description || "",
              };
            }
          }
        } catch {
          /* ignore */
        }
      })
  );
};

const loadPaymentMethods = async () => {
  const [depResp, witResp] = await Promise.all([
    PaymentService.getDepositPaymentMethodsV2(criteria),
    PaymentService.getWithdrawPaymentMethodsV2(criteria),
  ]);
  depositMethods.value = depResp.map((m: any) => ({
    ...m,
    status: m.status === 10,
  }));
  withdrawMethods.value = witResp.map((m: any) => ({
    ...m,
    status: m.status === 10,
  }));
};

const effectiveList = (siteId: number): number[] =>
  configValue.value[siteId] ?? configValue.value[0] ?? [];

const isMethodActive = (siteId: number, methodId: number) =>
  effectiveList(siteId).includes(methodId);

const ensureOwnList = (siteId: number) => {
  if (siteId === 0) return;
  if (!hasOwnConfig.value.has(siteId)) {
    configValue.value[siteId] = [...effectiveList(siteId)];
    metaBySite.value[siteId] = {
      ...(metaBySite.value[0] || {
        key: KEY_NAME,
        name: KEY_NAME,
        dataFormat: "Json",
        description: "",
      }),
    };
    hasOwnConfig.value.add(siteId);
  }
};

const onToggle = (siteId: number, methodId: number, newVal: boolean) => {
  ensureOwnList(siteId);
  const list = siteId === 0 ? configValue.value[0] : configValue.value[siteId];
  if (!list) {
    configValue.value[siteId] = newVal ? [methodId] : [];
    return;
  }
  const idx = list.indexOf(methodId);
  if (newVal && idx === -1) list.push(methodId);
  if (!newVal && idx > -1) list.splice(idx, 1);
};

const activeCount = (siteId: number) => effectiveList(siteId).length;

const persistSite = async (siteId: number) => {
  const meta = metaBySite.value[siteId] ||
    metaBySite.value[0] || {
      key: KEY_NAME,
      name: KEY_NAME,
      dataFormat: "Json",
      description: "",
    };
  await SystemService.updateConfigByKey("Public", siteId, KEY_NAME, {
    value: siteId === 0 ? configValue.value[0] : configValue.value[siteId],
    key: meta.key || KEY_NAME,
    name: meta.name || KEY_NAME,
    dataFormat: meta.dataFormat || "Json",
    description: meta.description || "",
  });
};

const saveSite = async (siteId: number) => {
  if (siteId !== 0 && !hasOwnConfig.value.has(siteId)) {
    ElNotification.info({
      title: "Info",
      message: `${
        siteTypeRows.find((s) => s.id === siteId)?.code
      } inherits DEF (no changes)`,
    });
    return;
  }
  isSubmitting.value = true;
  try {
    await persistSite(siteId);
    ElNotification.success({
      title: "Saved",
      message: `${
        siteTypeRows.find((s) => s.id === siteId)?.code
      } saved successfully.`,
    });
  } catch (e) {
    ElNotification.error({ title: "Error", message: "Save failed" });
    console.error(e);
  } finally {
    isSubmitting.value = false;
  }
};

const saveAll = async () => {
  isSubmitting.value = true;
  try {
    const ids = siteTypeRows
      .map((s) => s.id)
      .filter((id) => id === 0 || hasOwnConfig.value.has(id));
    await Promise.all(ids.map((id) => persistSite(id)));
    ElNotification.success({
      title: "Saved",
      message: "All configurations saved",
    });
  } catch (e) {
    ElNotification.error({ title: "Error", message: "Save All failed" });
    console.error(e);
  } finally {
    isSubmitting.value = false;
  }
};

const revertToInherited = async (siteId: number) => {
  if (siteId === 0) return;
  isSubmitting.value = true;
  try {
    const defList = [...(configValue.value[0] || [])];
    const meta = metaBySite.value[siteId] ||
      metaBySite.value[0] || {
        key: KEY_NAME,
        name: KEY_NAME,
        dataFormat: "Json",
        description: "",
      };
    await SystemService.updateConfigByKey("Public", siteId, KEY_NAME, {
      value: defList,
      key: meta.key || KEY_NAME,
      name: meta.name || KEY_NAME,
      dataFormat: meta.dataFormat || "Json",
      description: meta.description || "",
    });
    delete configValue.value[siteId];
    delete metaBySite.value[siteId];
    hasOwnConfig.value.delete(siteId);
    ElNotification.info({
      title: "Reverted",
      message: `${
        siteTypeRows.find((s) => s.id === siteId)?.code
      } now inherits DEF (synced)`,
    });
  } catch (e) {
    ElNotification.error({ title: "Error", message: "Revert failed" });
    console.error(e);
  } finally {
    isSubmitting.value = false;
  }
};

const openDrawer = (siteId: number) => {
  currentSiteId.value = siteId;
  drawerVisible.value = true;
};

const siteIdToCode = (id: number) => t(`type.siteType.${id}`);

const currentSiteTitleShort = computed(() =>
  currentSiteId.value === null ? "" : siteIdToCode(currentSiteId.value)
);
const currentSiteTitle = computed(
  () =>
    `Site ${currentSiteTitleShort.value} Configuration (${activeCount(
      currentSiteId.value ?? 0
    )}/${totalMethodCount.value})`
);

onMounted(async () => {
  try {
    await Promise.all([loadConfigs(), loadPaymentMethods()]);
  } finally {
    isLoading.value = false;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_LoadingRing = _resolveComponent("LoadingRing")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.$t("title.autoOpenAccountPaymentAccessConfig")), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_el_switch, {
          modelValue: hideActive.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((hideActive).value = $event)),
          "active-text": "Show Active Only",
          "inactive-text": "Show All",
          size: "large",
          disabled: isLoading.value || isSubmitting.value
        }, null, 8, ["modelValue", "disabled"]),
        _createVNode(_component_el_button, {
          class: "save-all-btn",
          type: "success",
          plain: "",
          disabled: isSubmitting.value || isLoading.value,
          onClick: saveAll
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("action.saveAll")), 1)
          ]),
          _: 1
        }, 8, ["disabled"])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      (isLoading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(_component_LoadingRing)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("table", _hoisted_9, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", _hoisted_10, [
                  _createElementVNode("th", _hoisted_11, _toDisplayString(_ctx.$t("title.siteType")), 1),
                  _createElementVNode("th", null, _toDisplayString(_ctx.$t("title.configuredCount")) + " / " + _toDisplayString(_ctx.$t("title.total")), 1),
                  _createElementVNode("th", _hoisted_12, _toDisplayString(_ctx.$t("action.action")), 1)
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(siteTypeRows, (site) => {
                  return _createElementVNode("tr", {
                    key: site.id
                  }, [
                    _createElementVNode("td", _hoisted_13, [
                      _createTextVNode(_toDisplayString(siteIdToCode(site.id)) + " ", 1),
                      (site.id !== 0 && !hasOwnConfig.value.has(site.id))
                        ? (_openBlock(), _createBlock(_component_el_tag, {
                            key: 0,
                            size: "small",
                            type: "info",
                            effect: "plain",
                            class: "ms-2"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("status.default")), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("td", null, _toDisplayString(activeCount(site.id)) + " / " + _toDisplayString(totalMethodCount.value), 1),
                    _createElementVNode("td", _hoisted_14, [
                      _createVNode(_component_el_button, {
                        class: "expand-collapse-btn",
                        type: "primary",
                        onClick: ($event: any) => (openDrawer(site.id))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("action.edit")), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ])
                  ])
                }), 64))
              ])
            ]),
            _createVNode(_component_el_drawer, {
              modelValue: drawerVisible.value,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((drawerVisible).value = $event)),
              "with-header": true,
              title: currentSiteTitle.value,
              size: "50%",
              "append-to-body": ""
            }, {
              default: _withCtx(() => [
                (currentSiteId.value !== null)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _hoisted_16,
                      (depositGroupsFiltered.value.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                            _createElementVNode("table", _hoisted_18, [
                              _createElementVNode("thead", null, [
                                _createElementVNode("tr", _hoisted_19, [
                                  _createElementVNode("th", _hoisted_20, _toDisplayString(_ctx.$t("title.paymentMethod")), 1),
                                  _createElementVNode("th", _hoisted_21, _toDisplayString(_ctx.$t("fields.serviceActive")), 1),
                                  _hoisted_22
                                ])
                              ]),
                              _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(depositGroupsFiltered.value, (group) => {
                                  return (_openBlock(), _createElementBlock(_Fragment, {
                                    key: 'dep-' + group.name
                                  }, [
                                    _createElementVNode("tr", null, [
                                      _createElementVNode("td", _hoisted_23, [
                                        _createElementVNode("h5", _hoisted_24, _toDisplayString(group.name), 1)
                                      ])
                                    ]),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.items, (method) => {
                                      return (_openBlock(), _createElementBlock("tr", {
                                        key: 'dep-' + method.id
                                      }, [
                                        _createElementVNode("td", null, [
                                          _createElementVNode("span", {
                                            class: _normalizeClass(["p-2", method.status ? '' : 'bg-warning rounded'])
                                          }, _toDisplayString(method.name), 3)
                                        ]),
                                        _createElementVNode("td", _hoisted_25, [
                                          _createElementVNode("label", _hoisted_26, [
                                            _createElementVNode("input", {
                                              class: "form-check-input center-switch",
                                              type: "checkbox",
                                              checked: method.status,
                                              disabled: ""
                                            }, null, 8, _hoisted_27)
                                          ])
                                        ]),
                                        _createElementVNode("td", _hoisted_28, [
                                          _createVNode(_component_el_switch, {
                                            "model-value": 
                            isMethodActive(currentSiteId.value, method.id)
                          ,
                                            "active-value": true,
                                            "inactive-value": false,
                                            disabled: isSubmitting.value,
                                            size: "medium",
                                            onChange: ($event: any) => (onToggle(currentSiteId.value, method.id, $event))
                                          }, null, 8, ["model-value", "disabled", "onChange"])
                                        ])
                                      ]))
                                    }), 128))
                                  ], 64))
                                }), 128))
                              ])
                            ])
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_29, " No Deposit Methods ")),
                      _hoisted_30,
                      (withdrawGroupsFiltered.value.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                            _createElementVNode("table", _hoisted_32, [
                              _createElementVNode("thead", null, [
                                _createElementVNode("tr", _hoisted_33, [
                                  _createElementVNode("th", _hoisted_34, _toDisplayString(_ctx.$t("title.paymentMethod")), 1),
                                  _createElementVNode("th", _hoisted_35, _toDisplayString(_ctx.$t("fields.serviceActive")), 1),
                                  _hoisted_36
                                ])
                              ]),
                              _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(withdrawGroupsFiltered.value, (group) => {
                                  return (_openBlock(), _createElementBlock(_Fragment, {
                                    key: 'wit-' + group.name
                                  }, [
                                    _createElementVNode("tr", null, [
                                      _createElementVNode("td", _hoisted_37, [
                                        _createElementVNode("h5", _hoisted_38, _toDisplayString(group.name), 1)
                                      ])
                                    ]),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.items, (method) => {
                                      return (_openBlock(), _createElementBlock("tr", {
                                        key: 'wit-' + method.id
                                      }, [
                                        _createElementVNode("td", null, [
                                          _createElementVNode("span", {
                                            class: _normalizeClass(["p-2", method.status ? '' : 'bg-warning rounded'])
                                          }, _toDisplayString(method.name), 3)
                                        ]),
                                        _createElementVNode("td", _hoisted_39, [
                                          _createElementVNode("label", _hoisted_40, [
                                            _createElementVNode("input", {
                                              class: "form-check-input center-switch",
                                              type: "checkbox",
                                              checked: method.status,
                                              disabled: ""
                                            }, null, 8, _hoisted_41)
                                          ])
                                        ]),
                                        _createElementVNode("td", _hoisted_42, [
                                          _createVNode(_component_el_switch, {
                                            "model-value": 
                            isMethodActive(currentSiteId.value, method.id)
                          ,
                                            "active-value": true,
                                            "inactive-value": false,
                                            disabled: isSubmitting.value,
                                            size: "medium",
                                            onChange: ($event: any) => (onToggle(currentSiteId.value, method.id, $event))
                                          }, null, 8, ["model-value", "disabled", "onChange"])
                                        ])
                                      ]))
                                    }), 128))
                                  ], 64))
                                }), 128))
                              ])
                            ])
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_43, "No Withdraw Methods")),
                      _createElementVNode("div", _hoisted_44, [
                        (currentSiteId.value !== 0 && hasOwnConfig.value.has(currentSiteId.value))
                          ? (_openBlock(), _createBlock(_component_el_button, {
                              key: 0,
                              class: "site-action-btn",
                              type: "warning",
                              disabled: isSubmitting.value,
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (revertToInherited(currentSiteId.value)))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t("action.setAsDefault")), 1)
                              ]),
                              _: 1
                            }, 8, ["disabled"]))
                          : _createCommentVNode("", true),
                        _createVNode(_component_el_button, {
                          class: "site-action-btn",
                          type: "success",
                          disabled: isSubmitting.value,
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (saveSite(currentSiteId.value)))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("action.save")) + " " + _toDisplayString(currentSiteTitleShort.value), 1)
                          ]),
                          _: 1
                        }, 8, ["disabled"])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["modelValue", "title"]),
            _hoisted_45
          ]))
    ])
  ]))
}
}

})